import {FormDrawer} from './FormDrawer';
import {DrawerProps} from '@mantine/core';
import {useProduct} from '../hooks/useProduct';
import {Product} from '../types';

export const AddFormDrawer = (props: DrawerProps) => {

    const {createRecord} = useProduct();

    return (
        <FormDrawer
            record={{
                id: '',
                productTitle: '',
                status: '',
                meteringServiceSnsTopicArn: '',
                productLogoS3Url: '',
                shortDescription: '',
                longDescription: '',
                highlightOne: '',
                supportDetails: '',
                productCategories: [],
                keywordsForSearchResults: [],
            } as unknown as Product}
            handleSubmit={createRecord}
            {...props}
        />
    );
};
